module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_14_NDRI.5872efb04b7ea640703ee915978943ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_14_NDRI.png
// module id = 776
// module chunks = 0